/* eslint-disable no-console */
import React from "react";
import Layout from "antd/lib/layout";
import ThemeFooter from "./components/footer";
import "./cashrent-theme.scss";
import { isPartnerSite } from "../../utils";

const { Content, Footer } = Layout;

const CashRent = ({ children }) => (
  <Layout className="ui-cashrent-layout">
    <Content
      className={"ui-cashrent-body"}
    >
      {children}
    </Content>
    {!isPartnerSite() && (
      <Footer>
        <ThemeFooter />
      </Footer>)
    }
    {/* <IntercomChat/>*/}
  </Layout>
);

export default CashRent;
